/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AddressLine,
    AddressLineFromJSON,
    AddressLineFromJSONTyped,
    AddressLineToJSON,
} from './';

/**
 * 
 * @export
 * @interface InputAdresss
 */
export interface InputAdresss {
    /**
     * 
     * @type {string}
     * @memberof InputAdresss
     */
    fieldType?: string;
    /**
     * 
     * @type {AddressLine}
     * @memberof InputAdresss
     */
    values: AddressLine;
    /**
     * 
     * @type {string}
     * @memberof InputAdresss
     */
    country?: string;
    /**
     * 
     * @type {number}
     * @memberof InputAdresss
     */
    limit?: number;
}

export function InputAdresssFromJSON(json: any): InputAdresss {
    return InputAdresssFromJSONTyped(json, false);
}

export function InputAdresssFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdresss {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fieldType': !exists(json, 'fieldType') ? undefined : json['fieldType'],
        'values': AddressLineFromJSON(json['values']),
        'country': !exists(json, 'country') ? undefined : json['country'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function InputAdresssToJSON(value?: InputAdresss | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fieldType': value.fieldType,
        'values': AddressLineToJSON(value.values),
        'country': value.country,
        'limit': value.limit,
    };
}


